import AdCampaignItemService from '@/bundles/Ad/services/AdCampaignItemService';
import { http } from '@/bundles/Http/factory/HttpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import AdCampaignItemToMapper from '@/bundles/Ad/mappers/AdCampaignItemToMapper';

function adCampaignItemServiceFactory () {
  return new AdCampaignItemService({
    transport: http,
    errorMapper: new ErrorMapper(),
    recordMapper: new AdCampaignItemToMapper(),
  });
}

export const adCampaignItemService = adCampaignItemServiceFactory();
